import { render } from "./EventDetailForm.vue?vue&type=template&id=a208190e&scoped=true"
import script from "./EventDetailForm.vue?vue&type=script&lang=js"
export * from "./EventDetailForm.vue?vue&type=script&lang=js"

import "./EventDetailForm.vue?vue&type=style&index=0&id=a208190e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a208190e"]])

export default __exports__